import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Api from '../Api';

const INITIAL_ROLE_SELECT_LIST = [{ key: '', value: '-Choose-' }];

class UserForm extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {
      roleSelectList: INITIAL_ROLE_SELECT_LIST,
    };
    this.renderInput = this.renderInput.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
  }

  componentDidMount() {
    Api.getRoleMapping().then((mapping) => {
      let roleSelectList = [...INITIAL_ROLE_SELECT_LIST];
      let roleKeys = Object.keys(mapping).sort();
      for (let roleKey of roleKeys) {
        roleSelectList.push({ key: roleKey, value: mapping[roleKey] });
      }
      this.setState({ roleSelectList: roleSelectList });
    });
  }

  static validate(values) {
    const errors = {};
    if (!values.email) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }

    if (!values.firstName) {
      errors.firstName = 'Required';
    }

    if (!values.lastName) {
      errors.lastName = 'Required';
    }

    if (!values.role || values.role.startsWith('-')) {
      errors.role = 'Required';
    }

    if (values.isCreate) {
      if (!values.password) {
        errors.password = 'Required';
      }
      if (!values.password2) {
        errors.password2 = 'Required';
      }
    }

    if (values.password && values.password.length < 14) {
      errors.password = 'Must be at least 14 characters';
    }

    if ((values.password || values.password2) && values.password !== values.password2) {
      errors.password2 = 'Passwords do not match';
    }

    return errors;
  }

  static warn(values) {
    const warnings = {};
    // if (values && values.email && values.email.indexOf('@readytouch.com') == -1) {
    //   warnings.email = 'Hmm, you are not using readytouch.com...'
    // }
    return warnings;
  }

  renderInput({ input, label, type, disabled, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <input
          className='pure-input-1-3'
          {...input}
          placeholder={label}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderSelect({ input, label, children, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <select className='pure-input-1-3' {...input} placeholder={label}>
          {children}
        </select>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderCheckbox({ input, label, type, meta: { touched, error, warning } }) {
    return (
      <div className='pure-controls'>
        <label className='pure-checkbox'>
          <input {...input} type='checkbox' /> {label}
        </label>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  render() {
    const { handleSubmit, pristine, reset, submitting, initialValues } = this.props;
    // console.log('initialValues', initialValues);
    let isCreate = initialValues.isCreate;

    return (
      <form
        className='user-form pure-form pure-form-aligned'
        style={{ padding: '20px 0' }}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <Field
            name='email'
            component={this.renderInput}
            type='email'
            label='Email'
            disabled={!isCreate}
          />
          <Field name='firstName' component={this.renderInput} type='text' label='First Name' />
          <Field name='lastName' component={this.renderInput} type='text' label='Last Name' />
          <Field name='role' component={this.renderSelect} label='Role'>
            {this.state.roleSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          {/*{isCreate && <Field name="password" component={this.renderInput} type="password" label="Password"/>}*/}
          {/*{isCreate && <Field name="password2" component={this.renderInput} type="password" label="Confirm Password"/>}*/}
          <Field name='password' component={this.renderInput} type='password' label='Password' />
          <Field
            name='password2'
            component={this.renderInput}
            type='password'
            label='Confirm Password'
          />
          {/*
          {isCreate &&
            <Field name="shouldChangePassword" component={this.renderCheckbox} type="checkbox" label="Change Password On Next Login"/>
          }
*/}
          <Field
            name='isDisabled'
            component={this.renderCheckbox}
            type='checkbox'
            label='Disabled'
          />
          <div className='pure-controls'>
            <button
              style={{ margin: '0 10px' }}
              className='pure-button pure-button-primary'
              type='submit'
              disabled={submitting}
            >
              {isCreate ? 'Create' : 'Update'}
            </button>
{/*
            <button className="pure-button pure-button-primary" disabled={pristine || submitting} onClick={reset}>
              Reset
            </button>
*/}
          </div>
          <input type='hidden' name='lastUpdatedBy' />
          <input type='hidden' name='isCreate' />
        </fieldset>
      </form>
    );
  }
}

// Decorate the form component
UserForm = reduxForm({
  form: 'userForm', // a unique name for this form
  validate: UserForm.validate,
  warn: UserForm.warn,
})(UserForm);

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/UserForm.js